import 'jquery';
import {plenigoLog} from './logger';

/**
 * see https://stripe.com/docs/testing
 */

(function ($, Stripe) {
  var form = $('form[data-submit="stripe-ideal"]');

  if (!form.length) {
    return;
  }

  var owner = form.data('config'),
    submit = form.find(':submit'),
    paymentMethodId = form.find('#stripe_ideal_form_payment_method'),
    paymentFormErrorMsg = form.find('#stripe_ideal_form_errorMsg'),
    statusField = $('#stripeStatusField'),
    stripe = Stripe(owner.publicKey, {
      locale: form.data('language'),
    }),
    elements = stripe.elements(),
    options = {
      // Custom styling can be passed to options when creating an Element
      style: {
        base: {
          padding: '10px 0px',
          color: '#000',
          fontSize: '14px',
          fontFamily: 'Inter, Ubuntu, sans serif',
          fontWeight: 500,
          '::placeholder': {
            color: '#7d7d7d',
          },
        },
      },
    },
    // we can prefill it a bit:
    //https://stripe.com/docs/js/elements_object/create_element?type=card#elements_create-options-value
    cardElement = elements ? elements.create('idealBank', options) : null;
  // vanilla event handling

  // disable submit (if isnt)
  submit.prop('disabled', true);

  /**
   *
   * handling events of stripe element
   * https://stripe.com/docs/js/element/events/on_change?type=cardElement#element_on_change-handler
   *
   */
  cardElement.on('change', function (event) {
    if (event.complete) {
      statusField.val('full');
      // unlockSubmit();
      submit.focus();
    } else if (event.error) {
      // show validation to customer
    } else {
      // lockSubmit();
      statusField.val('');
    }
    statusField.trigger('change');
  });

  /**
   *
   * https://stripe.com/docs/js/element/events/on_ready
   */
  cardElement.on('ready', function () {
    // resize iframe
    $(document).trigger('resize').trigger('plenigo.resize');
    plenigoLog.info('Stripe form fully rendered');
    // disbale again submit
    submit.prop('disabled', true);
  });

  /**
   * the whole magic is put in the submit event
   */
  form.on('submit', function (e) {
    var cardholderName = $('#stripe_ideal_form_owner').val(),
      cardholderEmail = $('#stripe_ideal_form_email').val();

    // we encountered some error.
    // lets face it our client
    if (paymentMethodId.val().length > 4) {
      return true;
    }

    // prevent our form from being submitted
    e.preventDefault();
    form.data('processing', true);

    // 1st remove all error messages
    form.find('#errorMessage').removeClass('has_errors');

    // 2nd we need the form data ourself
    $.when(
      // set deliveryCountry
      $.ajax({
        type: 'POST',
        url: form.data('url'),
        data: form.serializeArray(),
        dataType: 'json',
      })
    ).then(function (data) {
      plenigoLog.info('Posted deliveryCountry for ideal', {
        request: form.serializeArray(),
        response: data,
      });

      /**
       * 3rd now send all data to Stripe
       * https://stripe.com/docs/payments/ideal/set-up-payment#charge-sepa-pm
       */

      stripe.confirmIdealSetup(
        owner.clientSecret,
        {
          payment_method: {
            ideal: cardElement,
            billing_details: {
              name: cardholderName,
              email: cardholderEmail,
            },
          },

          // stripe will give up to this url
          return_url: form.data('return'),
        }
      ).then(function (result) {
        if (result.error) {
          // Display error.message in your UI.
          plenigoLog.error('Stripe iDeal Form Error: ');
          console.error('Stripe error', result.error);
          paymentFormErrorMsg.val(result.error.message);
          paymentMethodId.val('ERROR');
          form.data('processing', false);
          form.submit();
        } else {
          plenigoLog.error('Stripe iDeal Form Error: ');
          // this part is taken fom creditcard handling
          // not sure, if somebody come here
          paymentMethodId.val(result.setupIntent.payment_method);
          // The setup has succeeded. Display a success message.
          form.data('processing', false);
          form.submit();
        }
      });
    });
  });

  // start
  cardElement.mount('#stripeCardElement');

}(jQuery, window.Stripe));
